import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Container, Grid } from '@material-ui/core'
import clsx from 'clsx'
import PageMetaData from '@v4/utils/data/PageMetaData'
import { useCta9 } from './Cta9.hooks'
import Item from './componets/Item'

const Cta9 = props => {
	const [{ classes, columnsNumber, maxWidth, items, mobileAlignment, mobileButtonWidth }] = useCta9(props)

	return (
		<div className={clsx(classes.root, 'cta9')}>
			<Container maxWidth={maxWidth} className="cta9-content">
				<Grid container spacing={3} justify="center" className="cta9-items">
					{_.map(items, (key, index) => (
						<Grid
							item
							lg={12 / columnsNumber}
							md={12 / columnsNumber}
							sm={9}
							xs={12}
							key={key}
							className="cta9-item"
						>
							<Item
								key={key}
								group="items"
								itemKey={key}
								index={index}
								mobileAlignment={mobileAlignment}
								mobileButtonWidth={mobileButtonWidth}
							/>
						</Grid>
					))}
				</Grid>
			</Container>
		</div>
	)
}

Cta9.propTypes = {
	metaData: PropTypes.shape({
		columns: PropTypes.instanceOf(PageMetaData),
		mobileAlignment: PropTypes.instanceOf(PageMetaData),
		mobileButtonWidth: PropTypes.instanceOf(PageMetaData),
		overrideXsMargins: PropTypes.instanceOf(PageMetaData),
		xsMarginTop: PropTypes.instanceOf(PageMetaData),
		xsMarginBottom: PropTypes.instanceOf(PageMetaData),
	}).isRequired,
}

export default memo(Cta9)
